import { CsvSchema } from "@utils/csv";

export const insertIf = <T>(condition: any, ...elements: CsvSchema<T>) =>
  condition ? elements : [];
